import { Fragment, useEffect, useRef, useState } from "react";
import FAQPreview from "../../../components/common/FAQPreview";
import PublicFooterV2 from "../../../components/ui/PublicFooterV2";
import ClassicHowItWork from "../../../components/ui/hiw/ClassicHowItWork";
import ClosingPage from "../../../components/common/Closing";
import { ScrollRestoration } from "react-router-dom";
import { getLanguageContent } from "../../../utils/language/languageSelector";
import { FINANCIAL_INSIGHTS_LANDING_PAGE_SCHEMA } from "../../../utils/schemas/language/pages/financialInsightsLPSchema";
import { getSubscriptionFeatureDetails } from "../../../api/payments/subscriptionsAPI";
import FiSubscriptionPlans from "../../private/financial-insights/common/FiSubscriptionPlans";
import { INSIGHTS_HUB_SCHEMA } from "../../../utils/schemas/language/pages/insightsHubSchema";
import FiEcosytem from "../../private/financial-insights/common/FiEcosystem";
import FiInternalHeader from "../../private/financial-insights/common/FiInternalHeader";
import FiEcosytemZPattern from "../../private/financial-insights/common/FiEcosystemZPattern";
import FiReviews from "../../private/financial-insights/common/FiReviews";

function FinancialInsightsLandingPage({ langKey }) {
  const content = getLanguageContent(
    FINANCIAL_INSIGHTS_LANDING_PAGE_SCHEMA,
    langKey,
  );
  const common_content = getLanguageContent(INSIGHTS_HUB_SCHEMA);

  const plansSectionRef = useRef(null);
  const [loadingPricing, setLoadingPricing] = useState(true);
  const [featureData, setFeatureData] = useState(null);

  useEffect(() => {
    const loadPricingMatrix = async () => {
      try {
        const response = await getSubscriptionFeatureDetails(
          "financial_insights",
        );

        if (response.ok) {
          const data = await response.json();
          setFeatureData(data.subscription || null);
        } else {
          console.error(
            "Pricing channel returned a bad operational status code.",
          );
        }
      } catch (err) {
        console.error(
          "Error communicating with subscription feature details endpoint:",
          err,
        );
      } finally {
        setLoadingPricing(false);
      }
    };

    loadPricingMatrix();
  }, []);

  const handleScrollToPlans = () => {
    if (plansSectionRef.current) {
      const elementPosition =
        plansSectionRef.current.getBoundingClientRect().top;
      const absolutePosition = elementPosition + window.pageYOffset;
      const offsetPosition = absolutePosition - 90;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <Fragment>
      <ScrollRestoration />
      <main className="public-v2">
        <FiInternalHeader
          onSeePlansClick={handleScrollToPlans}
          content={{
            hero: common_content.hero,
            value_cards: common_content.value_cards,
          }}
        />

        <FiEcosytemZPattern content={common_content} />
        <FiReviews content={content} />
        <FiSubscriptionPlans
          sectionRef={plansSectionRef}
          featureData={featureData}
          content={common_content}
        />
        <FAQPreview
          title={common_content.faq.title}
          faqs={common_content.faq.items}
          more={false}
          maxWidthCard={true}
        />
        <ClosingPage
          title={content.closing_page.heading}
          description={content.closing_page.description}
          imageAlt={content.closing_page.image_alt}
          ctas={content.closing_page.ctas}
          image="closing_finances.png"
          imagePosition="right"
        />
      </main>
      <PublicFooterV2 />
    </Fragment>
  );
}

export default FinancialInsightsLandingPage;
